<template>
  <div v-show="imageURL" class="flex flex-row" @click="showContextMenu = false">
    <!-- Display feilds details -->
    <div class="w-1/4">
      <div
        v-bind:key="requiredField.id"
        v-for="requiredField in requiredFields"
        class="max-w-3xl p-4"
      >
        <div class="h-min bg-white rounded shadow-md">
          <h2 class="text-2xl font-bold text-gray-800">
            {{ requiredField.name }}
          </h2>
          <!-- <p class="text-gray-600">Name</p> -->
          <button @click="addPolygon(requiredField.annotationField.id)">
            add
          </button>
        </div>
      </div>
    </div>
    <!-- END END END  -->
    <div class="w-1/2">
      <div id="contextMenu" v-show="showContextMenu">
        <ul style="position: relative">
          <!-- <li @click="removePolygon(selectedPolygon)">
          Remove Polygon
        </li> -->
          <!-- <li>Move</li> -->
          <li
            @click="resetPolygonToOriginal(selectedPolygon)"
            class="border-b border-solid border-black"
          >
            Remove Polygon
          </li>
          <li
            @click="toggle(selectedPolygon)"
            class="border-b border-solid border-black"
          >
            Toggle
          </li>
          <li
            @click="dragSingle(selectedPolygon)"
            v-if="
              selectedPolygon &&
              polygons[parseInt(selectedPolygon.split('-')[1])].moveAdjacent
            "
            class="border-b border-solid border-black"
          >
            Drag Single Point
          </li>
          <li
            @click="resize(selectedPolygon)"
            v-if="
              selectedPolygon &&
              !polygons[parseInt(selectedPolygon.split('-')[1])].moveAdjacent
            "
            class="border-b border-solid border-black"
          >
            Resize Polygon
          </li>
          <!-- <li @click="crop()">Crop</li> -->
          <!-- <li -->
          <!-- @mouseenter="openColorMenu($event)"
          @mouseleave="showColorMenu = false"
        >
          Change Color
          <color-picker
            id="colorMenu"
            @mouseover="showContextMenu = true"
            v-if="showColorMenu"
            style="position: absolute; width: 250px"
            :top="colorDialogTop + 'px'"
            theme="light"
            :color="selectedPolygonColor"
            @changeColor="changeColor"
          />
        </li> -->
        </ul>
      </div>

      <div
        id="OCRIMAGE"
        class="border-black black-solid border-4 mx-auto mt-4"
        :style="
          'position:relative;width:' +
          imageWidth +
          'px;height:' +
          imageHeight +
          'px'
        "
        :key="refreshKey"
      >
        <ImageComponent
          id="picture"
          :url="imageURL"
          :arrayBuffer="arrayBuffer"
          :imageId="selectedImageID"
          style="z-index: 2 !important"
          @loaded="setDimensions()"
        />
        <svg
          id="canvas"
          class="w-full h-full"
          style="position: absolute; z-index: 3 !important; top: 0"
          v-show="imageHeight"
        >
          <defs>
            <pattern
              id="smallGrid"
              width="10"
              height="10"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M 10 0 L 0 0 0 10"
                fill="none"
                stroke="gray"
                stroke-width="0.5"
              />
            </pattern>
            <pattern
              id="grid"
              width="100"
              height="100"
              patternUnits="userSpaceOnUse"
            >
              <rect width="100" height="100" fill="url(#smallGrid)" />
              <path
                d="M 100 0 L 0 0 0 100"
                fill="none"
                stroke="gray"
                stroke-width="1"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
          <polygon
            @contextmenu.prevent="openContextMenu($event, polygon.id)"
            v-for="polygon in polygons"
            :key="polygon.id"
            :id="polygon.id"
            @click="selected(polygon.id)"
            @mouseenter="
              addPolygonLines(polygon.id);
              displayLabel(polygon.id, true);
            "
            @mousemove="move($event, polygon.id)"
            @mousedown="
              selected(polygon.id);
              saveOriginPoint($event);
            "
            @mouseup="deleteOriginPoint(polygon.id)"
            @mouseleave="
              deleteOriginPoint(polygon.id);
              displayLabel(polygon.id, false);
            "
            :points="polygon.polygonCoordinates"
            style="fill: transparent; stroke-width: 2"
            :style="
              'stroke:' +
              polygon.color +
              ';display:' +
              (polygon.display ? 'inline;' : 'none;')
            "
          />
        </svg>
        <span v-for="polygon in polygons" :key="polygon.id">
          <span
            :id="coordinate.id"
            class="dot absolute"
            style="z-index: 7 !important"
            :style="
              'top:' +
              coordinate.y +
              'px;left:' +
              coordinate.x +
              'px;background:' +
              polygon.color +
              ';display:' +
              (polygon.display ? 'inline;' : 'none;')
            "
            v-for="coordinate in polygon.coordinates"
            :key="coordinate.id"
            @mouseenter="
              drag($event, coordinate.id);
              addPolygonLines(polygon.id);
              displayLineX(coordinate.id, true);
              displayLineY(coordinate.id, true);
            "
            @mouseleave="
              displayLineX(coordinate.id, false);
              displayLineY(coordinate.id, false);
            "
          ></span>
        </span>
        <span
          v-for="polygon in polygons"
          :key="polygon.id + '-label'"
          :id="polygon.id + '-label'"
          class="absolute"
          :style="
            'top:' +
            polygon.labelCoordinates.y +
            'px;left:' +
            polygon.labelCoordinates.x +
            'px;font-size:12px;background-color:white;border-radius:2px;display:none;' +
            'transform: translate(-50%,-50%);'
          "
        >
          {{ polygon.title }}</span
        >
      </div>
      <div class="mx-auto w-full text-center">
        <div class="h-full mt-3 my-auto">
          <button
            @click="submitImage()"
            class="bg-woo hover:bg-hoverwoo text-whiteText label p-2 mb-2 mx-auto"
          >
            Submit Image
          </button>
        </div>
      </div>
      <div class="mx-auto w-full text-center" v-if="polygons.length != 1">
        <div class="h-full mt-3 my-auto">
          <button
            @click="toggleAll()"
            class="bg-woo hover:bg-hoverwoo text-whiteText label p-2 mb-2 mx-auto"
          >
            Toggle All
          </button>
        </div>
      </div>
    </div>

    <!-- Display polygon details -->
    <div
      class="w-1/4 md:flex md:flex-wrap flex flex-col mx-auto justify-center"
    >
      <div
        v-for="polygon in polygons"
        :key="polygon.id"
        :id="polygon.id + '-div'"
        class="border-2 border-black lg:w-1/3 sm:w-full border-solid m-2 p-1 flex flex-col"
        :style="'border-color:#' + polygon.color"
        @mouseenter="displayLabel(polygon.id, true)"
        @mouseleave="displayLabel(polygon.id, false)"
      >
        <!-- <div class="w-full mx-auto">
          <button
            v-if="polygons.length != 1"
            @click="removePolygon(polygon.id)"
            class="bg-woo hover:bg-hoverwoo text-whiteText label p-2  mx-auto"
          >
            &#x2717;
          </button>
        </div> -->
        <div class="w-full">
          <div class="flex flex-col">
            <div class="p-2 w-full flex flex-row justify-around items-center">
              <div class="m-1 h-10">
                {{ polygon.title }}
              </div>
              <div v-if="polygon.hasValue">
                <input
                  class="m-1 h-10 rounded input px-2"
                  v-model="polygon.value"
                />
              </div>
            </div>
            <div class="w-full flex flex-row justify-around p-2">
              <button
                v-if="polygon.coordinates.length == 0"
                @click="addPolygon(polygon.id)"
                class="bg-woo hover:bg-hoverwoo text-whiteText label p-2"
              >
                Add Polygon
              </button>
              <button
                v-if="polygon.coordinates.length != 0"
                @click="toggle(polygon.id)"
                class="bg-woo hover:bg-hoverwoo text-whiteText label p-2"
              >
                Toggle
              </button>

              <button
                v-if="polygons.length != 1"
                @click="toggleOthers(polygon.id)"
                class="bg-woo hover:bg-hoverwoo text-whiteText label p-2"
              >
                Toggle Others
              </button>
              <button
                v-if="polygon.coordinates.length != 0"
                @click="recenter(polygon.id)"
                class="bg-woo hover:bg-hoverwoo text-whiteText label p-2"
              >
                Re-Center
              </button>
              <button
                v-if="polygon.coordinates.length != 0"
                @click="resetPolygonToOriginal(polygon.id)"
                class="bg-woo hover:bg-hoverwoo text-whiteText label p-2"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
        <!-- <div
          class="flex flex-col w-full mx-auto mt-4 "
          v-for="(coordinate, index) in polygon.coordinates"
          :key="coordinate.id"
          :id="coordinate.id"
        >
          <div class="flex flex-row text-center ">
            <div
              class="w-1/3 h-full my-auto"
              @mouseenter="
                displayLineX(coordinate.id, true);
                displayLineY(coordinate.id, true);
              "
              @mouseleave="
                displayLineX(coordinate.id, false);
                displayLineY(coordinate.id, false);
              "
            >
              {{ "Point - " + (index + 1) }}
            </div>
            <input
              oninput="javascript: if (parseInt(this.value) > this.max) {this.value = this.max}; if(parseInt(this.value) < this.min) {this.value=this.min}"
              class="w-1/3 mx-1 h-10 rounded input pr-1"
              type="number"
              :min="0"
              :max="imageWidth"
              v-model="coordinate.x"
              @input="
                setParameters(coordinate.id, coordinate.x, 'x', true, true)
              "
              @mouseenter="displayLineX(coordinate.id, true)"
              @mouseleave="displayLineX(coordinate.id, false)"
            />
            <input
              oninput="javascript: if (parseInt(this.value) > this.max) {this.value = this.max}; if(parseInt(this.value) < this.min) {this.value=this.min}"
              class="w-1/3 mx-1 h-10 input pr-1"
              type="number"
              :min="0"
              :max="imageHeight"
              v-model="coordinate.y"
              @input="
                setParameters(coordinate.id, coordinate.y, 'y', true, true)
              "
              @mouseenter="displayLineY(coordinate.id, true)"
              @mouseleave="displayLineY(coordinate.id, false)"
            />
          </div>
        </div>
        <div class="w-1/2 mx-auto mt-2 text-center">
          <input
            @input="scale(polygon.id)"
            type="range"
            min="50"
            max="150"
            v-model="polygon.scale"
            class="slider"
            :style="'background:#' + polygon.color"
          />
        </div> -->
      </div>
      <!-- <div class="w-1/6 text-center h-full mt-3 my-auto">
        <button
          @click="addPolygon()"
          class="bg-woo hover:bg-hoverwoo text-whiteText label p-2 mb-2 mx-auto "
        >
          Add Polygon
        </button>
      </div> -->
    </div>
    <!-- <div
      class="w-1/2 border-black black-solid border-4 mx-auto"
      style="height:fit-content; width:fit-content;position:relative"
    >
      <canvas
        id="cropCanvas"
        :width="imageWidth"
        :height="imageHeight"
      ></canvas>
    </div> -->
  </div>
</template>

<script>
import _ from "lodash";
import Http, { OCR_ENDPOINTS } from "../request";
// import colorPicker from "@caohenghu/vue-colorpicker";
import ImageComponent from "../components/ImageComponent.vue";
import { Modal } from "../helpers/Modal";
export default {
  name: "",
  data() {
    return {
      requiredFields: [],
      loading: false,
      polygons: [],
      imageWidth: 0,
      imageHeight: 0,
      selectedPolygon: null,
      selectedPolygonColor: null,
      showColorMenu: false,
      showContextMenu: false,
      originalPolygons: [],
      index: 0,
      refreshKey: 0,
      imageURL: null,
      arrayBuffer: null,
      colorDialogTop: null,
      moveStartX: null,
      moveStartY: null,
    };
  },
  components: {
    ImageComponent,
    // colorPicker,
  },
  async created() {
    this.setOCRData();
  },
  props: ["selectedImageID"],
  watch: {
    async selectedImageID(val, oldVal) {
      this.polygons = [];
      this.originalPolygons = [];
      this.setOCRData();
    },
  },
  methods: {
    async getImage() {
      // this.$emit("loading", true);
      await Http()
        .get(OCR_ENDPOINTS.images + "/" + this.selectedImageID)
        .then((response) => {
          response.data.arrayBuffer = this.arrayBuffer;
          response.data.url = this.imageURL;
          this.index = 0;
          this.requiredFields = response.data.type.requiredFields;
          for (var field of response.data.type.requiredFields) {
            this.polygons.push({
              title: _.startCase(field.name),
              coordinates: [],
              width: null,
              height: null,
              labelCoordinates: { x: 0, y: 0 },
              display: false,
              id: "polygon-" + this.index,
              hasValue: field.name != "image",
              fieldId: field.id,
              value: null,
            });

            this.index++;
          }
          this.polygons.push({
            title: _.startCase(response.data.type.name),
            coordinates: [],
            width: null,
            height: null,
            labelCoordinates: { x: 0, y: 0 },
            display: false,
            id: "polygon-" + this.index,
            hasValue: false,
            fieldId: "feature",
            value: null,
          });
          this.index++;
          this.updateAnnotations(response.data.annotations);
          // this.$store.commit("updateBatchImages", response.data);
          // this.$emit("loading", false);
        });
    },
    updateAnnotations(annotations) {
      var update = false;
      var annotationsDoneByUser = annotations.filter(
        (annotation) => annotation.user.id == this.$store.state.userId
      );

      if (annotationsDoneByUser.length != 0) {
        for (var polygon of this.polygons) {
          var annotationsOfCurrentField = annotationsDoneByUser.filter(
            (annotation) => annotation.field.id == polygon.fieldId
          );
          if (annotationsOfCurrentField.length != 0) {
            update = true;
            var mostRecentDate = Date.parse(
              annotationsOfCurrentField[0].creationDate
            );
            var mostRecentDateIndex = 0;
            var index = 0;
            for (var dateAnnotation of annotationsOfCurrentField) {
              var annotationDate = Date.parse(dateAnnotation.creationDate);
              if (annotationDate > mostRecentDate) {
                mostRecentDate = annotationDate;
                mostRecentDateIndex = index;
              }
              index++;
            }

            var sortedCoordinates = annotationsOfCurrentField[
              mostRecentDateIndex
            ].coordinates.sort(function (a, b) {
              return a.id - b.id;
            });
            polygon.coordinates = _.cloneDeep(sortedCoordinates);
            polygon.value =
              annotationsOfCurrentField[mostRecentDateIndex].value;
          }
        }
      }
      if (update) {
        this.setPolygons();
      }
    },
    async setOCRData() {
      var imageObject = this.$store.state.batchImages.find(
        (image) => image.id == this.selectedImageID
      );
      this.arrayBuffer = imageObject.arrayBuffer;
      this.imageURL = imageObject.url;
      this.refreshKey++;
      await this.getImage();
    },
    setPolygons() {
      for (var i in this.polygons) {
        var polygon = this.polygons[i];
        polygon.width = this.getWidth(polygon.coordinates);
        polygon.height = this.getHeight(polygon.coordinates);
        if (polygon.moveAdjacent == null || polygon.moveAdjacent == undefined) {
          polygon.moveAdjacent = false;
        }
        if (polygon.coordinates.length != 0) {
          polygon.display = true;
        } else {
          polygon.display = false;
        }
        // if (!polygon.scale) {
        //   polygon.scale = 100;
        // }
        if (!polygon.id) {
          polygon.id = "polygon-" + this.index;
          this.index++;
        }
        if (!polygon.color) {
          polygon.color = this.getRandomColor();
        }
        polygon.polygonCoordinates = "";
        var yCoordinate = [];
        var xCoordinate = [];
        for (var j in polygon.coordinates) {
          var coordinate = polygon.coordinates[j];
          if (!coordinate.scaleX && !coordinate.scaleX) {
            coordinate.scaleX = coordinate.x;
            coordinate.scaleY = coordinate.y;
          }
          yCoordinate.push(coordinate.y);
          xCoordinate.push(coordinate.x);
          coordinate.id = polygon.id + "-dot-" + j;
          coordinate.lineX = {
            x1: coordinate.x,
            x2: coordinate.x,
            y1: 0,
            y2: this.imageHeight,
          };
          coordinate.lineY = {
            x1: 0,
            x2: this.imageWidth,
            y1: coordinate.y,
            y2: coordinate.y,
          };
          this.addCoordinateLines(coordinate.id);
          polygon.polygonCoordinates += coordinate.x + "," + coordinate.y + " ";
        }
        if (polygon.coordinates.length != 0) {
          var center = this.getCenter(polygon.coordinates);
          polygon.labelCoordinates = {
            x: center.x,
            y: center.y,
          };
        }
        polygon.polygonCoordinates = polygon.polygonCoordinates.trim();
      }
    },
    getRandomColor() {
      var rgb = [0, 0, 0];
      var color = "rgb(";
      var index = parseInt(Math.random() * 3);
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = parseInt(Math.random() * 151);
      }
      rgb[index] = 150;
      color += rgb.join(",");
      color += ")";
      return color;
    },
    submitImage() {
      Modal.showConfirmationModal({
        message: "Are You Sure You Would Like to Proceed?",
        title: "Confirm Details",
      }).then((confirmed) => {
        if (confirmed) {
          // this.$emit("loading", true);
          var annotatedFields = [];
          for (var polygon of this.polygons) {
            var coordinates = [];
            for (var coordinate of polygon.coordinates) {
              coordinates.push({ x: coordinate.x, y: coordinate.y });
            }
            if (coordinates.length != 0) {
              annotatedFields.push({
                imageAnnotationFieldId: polygon.fieldId,
                annotationValue: polygon.value,
                coordinates: coordinates,
              });
            }
          }
          Http()
            .post(OCR_ENDPOINTS.imagesAnnotation, {
              imageId: this.selectedImageID,
              annotatedFields: annotatedFields,
            })
            .then((response) => {
              this.$emit("reset");
            });
        }
      });
    },
    openContextMenu(event, id) {
      this.showContextMenu = true;
      this.selected(id);
      this.colorDialogTop = document.getElementById("contextMenu").style.height;
      if (document.body.clientWidth < event.pageX + 200) {
        document.getElementById("contextMenu").style.right =
          document.body.clientWidth - event.pageX + "px";
        document.getElementById("contextMenu").style.left = "auto";
      } else {
        document.getElementById("contextMenu").style.left = event.pageX + "px";
        document.getElementById("contextMenu").style.right = "auto";
      }
      document.getElementById("contextMenu").style.top = event.pageY + "px";
      if (document.getElementById(id)) {
        this.selectedPolygonColor = document.getElementById(id).style.stroke;
      }
    },
    openColorMenu(event) {
      this.showColorMenu = true;
      // if (
      //   document.body.clientWidth < event.pageX + 450 &&
      //   document.getElementById("colorMenu")
      // ) {
      //   document.getElementById("colorMenu").style.left = -250 + "px";
      //   document.getElementById("colorMenu").style.right = "auto";
      // } else if (document.getElementById("colorMenu")) {
      //   document.getElementById("colorMenu").style.right = -250 + "px";
      //   document.getElementById("colorMenu").style.left = "auto";
      // }
    },
    resetPolygonToOriginal(id) {
      this.removePolygon(id);
      // var original = this.originalPolygons.find((polygon) => {
      //   return polygon.id == id;
      // });
      // var updated = this.polygons.find((polygon) => {
      //   return polygon.id == id;
      // });
      // updated.coordinates = _.cloneDeep(original.coordinates);
      // this.setPolygons();
    },
    recenter(id) {
      var coordinates = this.polygons.find(
        (element) => element.id == id
      ).coordinates;
      var centerCoordinate = {
        x: parseInt(this.imageWidth / 2),
        y: parseInt(this.imageHeight / 2),
      };
      var radius = 100;
      var startingRadian;
      var angle = ((360 / coordinates.length) * Math.PI) / 180;
      if (coordinates.length % 2 != 0) {
        startingRadian = 0;
      } else {
        startingRadian = -(angle / 2);
      }
      for (var coordinate of coordinates) {
        coordinate.adjacentCoordinateX = null;
        coordinate.adjacentCoordinateY = null;
        var distanceX = centerCoordinate.x + radius * Math.sin(startingRadian);
        var distanceY = centerCoordinate.y + radius * Math.cos(startingRadian);
        if (Math.abs(distanceX - coordinate.x) > 1) {
          this.setParameters(
            coordinate.id,
            parseInt(distanceX),
            "x",
            true,
            true
          );
        }
        if (Math.abs(distanceY - coordinate.y) > 1) {
          this.setParameters(
            coordinate.id,
            parseInt(distanceY),
            "y",
            true,
            true
          );
        }
        startingRadian += angle;
      }
    },
    setParameters(id, value, axis, scaled, line) {
      var splitId = id.split("-");
      var coordinate = this.polygons.find(
        (element) => element.id == splitId[0] + "-" + splitId[1]
      ).coordinates[parseInt(splitId[3])];
      if (axis == "x") {
        coordinate.x = value;
        if (scaled) {
          coordinate.scaleX = value;
        }
        if (line && document.getElementById(coordinate.id + "-lineX")) {
          document
            .getElementById(coordinate.id + "-lineX")
            .setAttribute("x1", value);
          document
            .getElementById(coordinate.id + "-lineX")
            .setAttribute("x2", value);
        }
      } else if (axis == "y") {
        coordinate.y = value;
        if (scaled) {
          coordinate.scaleY = value;
        }
        if (line && document.getElementById(coordinate.id + "-lineX")) {
          document
            .getElementById(coordinate.id + "-lineY")
            .setAttribute("y1", value);
          document
            .getElementById(coordinate.id + "-lineY")
            .setAttribute("y2", value);
        }
      }
      this.setPolygons();
    },
    getHeight(coordinates) {
      var yCoordinate = [];
      for (var point of coordinates) {
        yCoordinate.push(point.y);
      }
      return Math.max(...yCoordinate) - Math.min(...yCoordinate);
    },
    getWidth(coordinates) {
      var xCoordinate = [];
      for (var point of coordinates) {
        xCoordinate.push(point.x);
      }
      return Math.max(...xCoordinate) - Math.min(...xCoordinate);
    },
    getCenter(coordinates) {
      var xCoordinate = [];
      var yCoordinate = [];
      for (var point of coordinates) {
        xCoordinate.push(point.scaleX);
        yCoordinate.push(point.scaleY);
      }
      let average = (array) =>
        parseInt(array.reduce((a, b) => a + b) / array.length);
      return { x: average(xCoordinate), y: average(yCoordinate) };
    },
    setDimensions() {
      // this.$emit("loading", false);
      this.imageWidth = document.getElementById("picture").naturalWidth;
      this.imageHeight = document.getElementById("picture").naturalHeight;
      document.getElementById("OCRIMAGE").style.height =
        this.imageHeight + "px";
      document.getElementById("OCRIMAGE").style.width = this.imageWidth + "px";
      document.getElementById("canvas").style.height = this.imageHeight + "px";
      document.getElementById("canvas").style.width = this.imageWidth + "px";
      document.getElementById("picture").style.height = this.imageHeight + "px";
      document.getElementById("picture").style.width = this.imageWidth + "px";
      this.setPolygons();
      this.originalPolygons = _.cloneDeep(this.polygons);
    },
    dragSingle(id) {
      this.polygons.find((element) => element.id == id).moveAdjacent = false;
      this.resetAdjacents(id);
    },
    resetAdjacents(id) {
      for (var coordinate of this.polygons.find((element) => element.id == id)
        .coordinates) {
        coordinate.adjacentCoordinateX = null;
        coordinate.adjacentCoordinateY = null;
      }
    },
    resize(id) {
      this.polygons.find((element) => element.id == id).moveAdjacent = true;
      this.resetAdjacents(id);
    },
    saveOriginPoint(event) {
      this.moveStartX = event.offsetX;
      this.moveStartY = event.offsetY;
    },
    deleteOriginPoint(id) {
      var coordinates = this.polygons.find(
        (element) => element.id == id
      ).coordinates;
      for (var coordinate of coordinates) {
        this.setParameters(coordinate.id, coordinate.y, "y", true, true);
        this.setParameters(coordinate.id, coordinate.x, "x", true, true);
      }
      this.moveStartX = null;
      this.moveStartY = null;
    },
    move(event, id) {
      if (this.moveStartX && this.moveStartY && this.selectedPolygon == id) {
        var coordinates = this.polygons.find(
          (element) => element.id == id
        ).coordinates;
        var moveable = true;
        for (var coordinate of coordinates) {
          var top = coordinate.scaleY + (event.offsetY - this.moveStartY);
          var left = coordinate.scaleX + (event.offsetX - this.moveStartX);
          if (
            this.imageHeight < top ||
            top < 0 ||
            this.imageWidth < left ||
            left < 0
          ) {
            moveable = false;
          }
        }
        if (moveable) {
          for (var coordinate of coordinates) {
            var top = coordinate.scaleY + (event.offsetY - this.moveStartY);
            var left = coordinate.scaleX + (event.offsetX - this.moveStartX);
            if (
              this.imageHeight > top &&
              top > 0 &&
              this.imageWidth > left &&
              left > 0
            ) {
              var elmnt = document.getElementById(coordinate.id);
              this.setParameters(coordinate.id, top, "y", false, true);
              elmnt.style.top = top + "px";
              this.setParameters(coordinate.id, left, "x", false, true);
              elmnt.style.left = left + "px";
            }
          }
        }
      }
    },
    detectBrowser() {
      if (
        (navigator.userAgent.indexOf("Opera") ||
          navigator.userAgent.indexOf("OPR")) != -1
      ) {
        return "Opera";
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        return "Chrome";
      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        return "Safari";
      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        return "Firefox";
      } else if (
        navigator.userAgent.indexOf("MSIE") != -1 ||
        !!document.documentMode == true
      ) {
        return "IE";
      } else {
        return "Unknown";
      }
    },
    drag(event, id) {
      var splitId = id.split("-");
      let self = this;
      dragElement(event.target);
      function dragElement(elmnt) {
        var pos1 = 0,
          pos2 = 0,
          pos3 = 0,
          pos4 = 0;
        if (elmnt) elmnt.onmousedown = dragMouseDown;

        function dragMouseDown(e) {
          e = e || window.event;
          e.preventDefault();
          if (self.detectBrowser() == "Firefox") {
            pos3 = e.screenX;
            pos4 = e.screenY;
          } else {
            pos3 = e.clientX;
            pos4 = e.clientY;
          }
          document.onmouseup = closeDragElement;
          document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
          e = e || window.event;
          e.preventDefault();
          if (self.detectBrowser() == "Firefox") {
            pos1 = pos3 - e.screenX;
            pos2 = pos4 - e.screenY;
            pos3 = e.screenX;
            pos4 = e.screenY;
          } else {
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
          }

          var top = elmnt.offsetTop - pos2;
          var left = elmnt.offsetLeft - pos1;
          var coordinate = self.polygons.find(
            (element) => element.id == splitId[0] + "-" + splitId[1]
          ).coordinates[parseInt(splitId[3])];
          var moveAdjacent = self.polygons.find(
            (element) => element.id == splitId[0] + "-" + splitId[1]
          ).moveAdjacent;
          var coordinates = self.polygons.find(
            (element) => element.id == splitId[0] + "-" + splitId[1]
          ).coordinates;
          var adjacentCoordinateX = coordinate.adjacentCoordinateX,
            adjacentCoordinateY = coordinate.adjacentCoordinateY;
          for (var point of coordinates) {
            if (
              coordinate.x == point.x &&
              !adjacentCoordinateX &&
              point.id != adjacentCoordinateY &&
              point.id != coordinate.id
            ) {
              adjacentCoordinateX = point.id;
              coordinate.adjacentCoordinateX = point.id;
            }
            if (
              coordinate.y == point.y &&
              !adjacentCoordinateY &&
              point.id != adjacentCoordinateX &&
              point.id != coordinate.id
            ) {
              adjacentCoordinateY = point.id;
              coordinate.adjacentCoordinateY = point.id;
            }
          }
          if (self.imageHeight > top && top > 0) {
            self.setParameters(coordinate.id, top, "y", true, true);
            elmnt.style.top = top + "px";
            if (
              adjacentCoordinateY &&
              document.getElementById(adjacentCoordinateY) &&
              moveAdjacent
            ) {
              document.getElementById(adjacentCoordinateY).style.top =
                top + "px";
              self.setParameters(adjacentCoordinateY, top, "y", true, true);
            } else if (
              adjacentCoordinateY &&
              !document.getElementById(adjacentCoordinateY)
            ) {
              coordinate.adjacentCoordinateY = null;
            }
          }
          if (self.imageWidth > left && left > 0) {
            self.setParameters(coordinate.id, left, "x", true, true);
            elmnt.style.left = left + "px";
            if (
              adjacentCoordinateX &&
              document.getElementById(adjacentCoordinateX) &&
              moveAdjacent
            ) {
              self.setParameters(adjacentCoordinateX, left, "x", true, true);
              document.getElementById(adjacentCoordinateX).style.left =
                left + "px";
            } else if (
              adjacentCoordinateY &&
              !document.getElementById(adjacentCoordinateX)
            ) {
              coordinate.adjacentCoordinateX = null;
            }
          }
          // self.polygons.find(
          //   (element) => element.id == splitId[0] + "-" + splitId[1]
          // ).scale = 100;
        }

        function closeDragElement() {
          document.onmouseup = null;
          document.onmousemove = null;
        }
      }
    },
    selected(id) {
      this.selectedPolygon = id;
    },
    changeColor(color) {
      var polygon = this.polygons.find(
        (element) => element.id == this.selectedPolygon
      );
      polygon.color =
        "rgb(" + color.rgba.r + "," + color.rgba.g + "," + color.rgba.b + ")";
      this.selectedPolygonColor =
        "rgb(" + color.rgba.r + "," + color.rgba.g + "," + color.rgba.b + ")";
    },
    toggle(id) {
      var index = this.polygons.findIndex((element) => element.id == id);
      this.polygons[index].display = !this.polygons[index].display;
    },
    toggleAll() {
      for (var polygon of this.polygons) {
        this.toggle(polygon.id);
      }
    },
    toggleOthers(id) {
      var index = this.polygons.findIndex((element) => element.id == id);
      for (var i = 0; i < this.polygons.length; i++) {
        if (i == index) {
          this.polygons[i].display = true;
        } else {
          this.polygons[i].display = false;
        }
      }
    },
    removePolygonCoordinateLines(id) {
      var coordinates = this.polygons.find(
        (element) => element.id == id
      ).coordinates;
      for (var coordinate of coordinates) {
        this.removePointCoordinateLines(coordinate.id);
      }
    },
    displayLabel(id, trigger) {
      var index = this.polygons.findIndex((element) => element.id == id);
      if (document.getElementById(id + "-label"))
        document.getElementById(id + "-label").style.display =
          trigger && this.polygons[index].display ? "inline" : "none";
    },
    displayLineY(id, trigger) {
      if (document.getElementById(id + "-lineY"))
        document
          .getElementById(id + "-lineY")
          .setAttribute("stroke", trigger ? "red" : "transparent");
    },
    displayLineX(id, trigger) {
      if (document.getElementById(id + "-lineX"))
        document
          .getElementById(id + "-lineX")
          .setAttribute("stroke", trigger ? "red" : "transparent");
    },
    addPolygonLines(id) {
      var polygon = this.polygons.find((element) => element.id == id);
      for (var coordinate of polygon.coordinates) {
        this.addCoordinateLines(coordinate.id);
      }
    },
    addCoordinateLines(id) {
      var splitId = id.split("-");
      var coordinate = this.polygons.find(
        (element) => element.id == splitId[0] + "-" + splitId[1]
      ).coordinates[parseInt(splitId[3])];
      if (
        !document.getElementById(coordinate.id + "-lineY") &&
        !document.getElementById(coordinate.id + "-lineX")
      ) {
        var svg = document.getElementById("canvas");
        var lineX = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "line"
        );
        lineX.setAttribute("id", coordinate.id + "-lineX");
        for (var property of Object.keys(coordinate.lineX)) {
          lineX.setAttribute(property, coordinate.lineX[property]);
        }
        lineX.setAttribute("stroke", "none");
        lineX.setAttribute("stroke-width", "1");
        var lineY = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "line"
        );
        lineY.setAttribute("id", coordinate.id + "-lineY");
        for (var property of Object.keys(coordinate.lineY)) {
          lineY.setAttribute(property, coordinate.lineY[property]);
        }
        lineY.setAttribute("stroke", "none");
        lineY.setAttribute("stroke-width", "1");
        svg.append(lineX);
        svg.append(lineY);
      }
    },
    removePointCoordinateLines(id) {
      document.getElementById(id + "-lineX").remove();
      document.getElementById(id + "-lineY").remove();
    },
    addPolygon(id) {
      var index = this.polygons.findIndex((element) => element.id == id);
      var centerHeight = this.imageHeight / 2;
      var centerWidth = this.imageWidth / 2;
      var newCoordinates = [
        { x: centerWidth - 50, y: centerHeight - 50 },
        { x: centerWidth + 50, y: centerHeight - 50 },
        { x: centerWidth + 50, y: centerHeight + 50 },
        { x: centerWidth - 50, y: centerHeight + 50 },
      ];
      this.polygons[index].coordinates = newCoordinates;
      this.setPolygons();
    },
    // scale(id) {
    //   var multiplier =
    //     this.polygons.find((element) => element.id == id).scale / 100;
    //   var centerCoordinate = this.getCenter(
    //     this.polygons.find((element) => element.id == id).coordinates
    //   );
    //   for (var coordinate of this.polygons.find((element) => element.id == id)
    //     .coordinates) {
    //     var distanceX = Math.abs(coordinate.scaleX - centerCoordinate.x);
    //     var distanceY = Math.abs(coordinate.scaleY - centerCoordinate.y);
    //     var differenceX = distanceX * multiplier - distanceX;
    //     var differenceY = distanceY * multiplier - distanceY;
    //     if (
    //       coordinate.x < centerCoordinate.x &&
    //       coordinate.x - differenceX > 0
    //     ) {
    //       this.setParameters(
    //         coordinate.id,
    //         coordinate.scaleX - parseInt(differenceX),
    //         "x",
    //         false,
    //         true
    //       );
    //     } else if (
    //       coordinate.x > centerCoordinate.x &&
    //       coordinate.x + differenceX <= this.imageWidth
    //     ) {
    //       this.setParameters(
    //         coordinate.id,
    //         coordinate.scaleX + parseInt(differenceX),
    //         "x",
    //         false,
    //         true
    //       );
    //     }
    //     if (
    //       coordinate.y < centerCoordinate.y &&
    //       coordinate.y - differenceY > 0
    //     ) {
    //       this.setParameters(
    //         coordinate.id,
    //         coordinate.scaleY - parseInt(differenceY),
    //         "y",
    //         false,
    //         true
    //       );
    //     } else if (
    //       coordinate.y > centerCoordinate.y &&
    //       coordinate.y + differenceY <= this.imageHeight
    //     ) {
    //       this.setParameters(
    //         coordinate.id,
    //         coordinate.scaleY + parseInt(differenceY),
    //         "y",
    //         false,
    //         true
    //       );
    //     }
    //   }
    // },
    // crop() {
    //   var canvas = document.getElementById("cropCanvas");
    //   var context = canvas.getContext("2d");
    //   context.beginPath();
    //   context.restore();
    //   var index = 0;
    //   for (var coordinate of this.polygons[0].coordinates) {
    //     if (index == 0) {
    //       context.moveTo(coordinate.x, coordinate.y);
    //     } else {
    //          context.lineTo(coordinate.x, coordinate.y);
    //     }
    //       console.log(coordinate.x, coordinate.y)
    //     index++;
    //   }
    //   context.lineTo(
    //     this.polygons[0].coordinates[0].x,
    //     this.polygons[0].coordinates[0].y
    //   );
    //   context.save()
    //  context.clip();
    //  var canvas = document.getElementById("cropCanvas");
    //  var context = canvas.getContext("2d");
    //  var img = document.getElementById("picture");
    //  context.drawImage(img, 0, 0);
    // },
    // removePoint(id) {
    //   var splitId = id.split("-");
    //   this.polygons[parseInt(splitId[1])].coordinates.splice(
    //     parseInt(splitId[3]),
    //     1
    //   );
    //   this.setPolygons();
    // },
    // regularize(id) {
    //   var coordinates = this.polygons.find((element) => element.id == id)
    //     .coordinates;
    //   var centerCoordinate = this.getCenter(coordinates);
    //   var radius = 100;
    //   var startingRadian;
    //   var angle = ((360 / coordinates.length) * Math.PI) / 180;
    //   if (coordinates.length % 2 != 0) {
    //     startingRadian = 0;
    //   } else {
    //     startingRadian = -(angle / 2);
    //   }
    //   for (var coordinate of coordinates) {
    //     coordinate.adjacentCoordinateX = null;
    //     coordinate.adjacentCoordinateY = null;
    //     var distanceX = centerCoordinate.x + radius * Math.sin(startingRadian);
    //     var distanceY = centerCoordinate.y + radius * Math.cos(startingRadian);
    //     if (Math.abs(distanceX - coordinate.x) > 1) {
    //       this.setParameters(
    //         coordinate.id,
    //         parseInt(distanceX),
    //         "x",
    //         true,
    //         true
    //       );
    //     }
    //     if (Math.abs(distanceY - coordinate.y) > 1) {
    //       this.setParameters(
    //         coordinate.id,
    //         parseInt(distanceY),
    //         "y",
    //         true,
    //         true
    //       );
    //     }
    //     startingRadian += angle;
    //   }
    //   this.polygons.find((element) => element.id == id).scale = 100;
    // },
    removePolygon(id) {
      this.removePolygonCoordinateLines(id);
      var index = this.polygons.findIndex((polygon) => {
        return polygon.id == id;
      });
      this.polygons[index].coordinates = [];
      this.polygons[index].value = null;
      this.setPolygons();
      this.selectedPolygon = null;
    },

    // addPolygon() {
    //   var newCoordinates;
    //   if (this.polygons.length != 0) {
    //     var newCoordinates = _.cloneDeep(
    //       this.polygons[this.polygons.length - 1].coordinates
    //     );
    //   } else {
    //     newCoordinates = [
    //       { x: 0, y: 0 },
    //       { x: 0, y: 100 },
    //       { x: 100, y: 100 },
    //       { x: 100, y: 0 },
    //     ];
    //   }
    //   for (var point of newCoordinates) {
    //     if (point.x + 10 <= this.imageWidth) {
    //       point.x += 10;
    //     }
    //     if (point.y + 10 <= this.imageHeight) {
    //       point.y += 10;
    //     }
    //   }
    //   this.polygons.push({
    //     width: null,
    //     height: null,
    //     coordinates: newCoordinates,
    //   });
    //   this.setPolygons();
    // },
    // addPoint(id) {
    //   var coordinates = this.polygons.find(element => element.id==id).coordinates;
    //   var centerCoordinate = this.getCenter(coordinates);
    //   coordinates.push({
    //     id: coordinates.length,
    //     x: centerCoordinate.x,
    //     y: centerCoordinate.y,
    //   });
    //   this.setPolygons();
    // },
    // move(e) {
    // console.log(e);
    // let self = this;
    // if (this.selectedPolygon) {
    //   for (var coordinate of this.coordinates) {
    //     console.log(e.target.animatedPoints);
    //     if (self.imageHeight > 0) {
    //       coordinate.y = 0;
    //     }
    //     if (self.imageWidth > 0) {
    //       coordinate.x = 0;
    //     }
    //   }
    // }
    // },
  },
};
</script>
<style scoped>
.dot {
  height: 10px;
  width: 10px;
  background-color: rgb(35, 79, 255);
  display: inline-block;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 25px;
  outline: none;
  opacity: 0.7;
  border: black 1px solid;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: black;
  cursor: pointer;
}

#contextMenu {
  width: 200px;
  position: absolute;
  border: 2px black solid;
  z-index: 10;
}

#contextMenu ul li {
  background: #ccc;
}

#contextMenu ul li:hover {
  background: rgb(108, 179, 255);
}

svg {
  stroke-dasharray: 0%;
}
</style>
